import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/img_1.jpg'


const _withScopeId = n => (_pushScopeId("data-v-55f95fb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-fluid header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-start" }, [
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("h1", null, [
        /*#__PURE__*/_createElementVNode("span", null, "Production"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Accounting ")
      ])
    ])
  ])
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  class: "container",
  ref: "about-section"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "text-start heading" }, "About")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Vue logo",
      src: _imports_0,
      class: "img-fluid"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 text-start diverse" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "diverse-title" }, " Diverse Production Services delivers world-class production and payroll accounting services to world-class clients. "),
    /*#__PURE__*/_createElementVNode("p", null, " Looking for an on-the-field or remote production accountant? From pre-to-post-production, our expert teams have experience with all aspects of production and payroll accounting and will work with you hand in hand to accomplish your goals. From small indie projects to big, studio-level productions, we have you covered. "),
    /*#__PURE__*/_createElementVNode("p", null, " Diverse Production Services has deep familiarity with industry production accounting software. We fit within your workflow and offer to help streamline any broken processes. "),
    /*#__PURE__*/_createElementVNode("p", null, " Our mission is to provide superior service, customized to each client’s needs. We strive to always be prepared, proactive, reliable, and responsive while consistently delivering quality work. We commit to decency, respect, and good manners as the industry standard – our belief is that the individuals who work in our trade are as important as the productions themselves. ")
  ])
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  class: "demo_form",
  ref: "contact-section"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Contact our team for a quote!", -1))
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "row d-flex justify-content-center" }
const _hoisted_12 = { class: "col-md-9 col-xs-12" }
const _hoisted_13 = {
  key: 0,
  class: "alert alert-success mt-2",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_form_generator = _resolveComponent("form-generator")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header, { onScrollToElement: _ctx.scrollByClass }, null, 8, ["onScrollToElement"]),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _hoisted_7, 512)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_form_generator, {
              schema: _ctx.schema,
              submitButton: _ctx.submitButton,
              onUpdatedForm: _ctx.validForm,
              ref: "supportForm"
            }, null, 8, ["schema", "submitButton", "onUpdatedForm"])
          ])
        ]),
        (_ctx.onSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Message has been sent successfully!! "))
          : _createCommentVNode("", true)
      ])
    ], 512),
    _createVNode(_component_Footer)
  ]))
}